module.exports = __webpack_public_path__ + "static/media/ntbc-logo3.02963414.png";